export default {
  MODULE_NAME: 'vetting',
};
